import React from "react";


export default function NewStudent(props) {


return(<div>NewStudent</div>)
}